export default "__VITE_ASSET__BVGCp8$G__"